// source: https://stackoverflow.com/a/8027444
export function isValidHexColor(color: string) {
  return /^(?:[0-9a-fA-F]{3}){1,2}$/.test(color);
}
